import { Conn_Db_Obj_Lnk } from '../conn_Db_Obj_Lnk';
import { DxFlow_Obj_Property } from './dxflow_obj_property';
import { Obj_Db_Property } from '../datapoint/obj_db_property';
import { KafkaProducerJob_Inst } from './kafkaProducerJob_Inst';
import { CommonEnums } from '../../common.enums';
import { Obj_Db_PropertiesUtil } from '../../utils/obj_db_properties.util';
import { Conn_Db_Obj_LnksUtil } from '../../utils/conn_db_obj_lnks.util';
import { DxFlow_Obj_PropertiesUtil } from '../../utils/dxflow_obj_properties.util';

export class KafkaProducerJob {

    kafkaProducerJob_Inst: KafkaProducerJob_Inst;
    conn_Db_Obj_Lnks: Array<Conn_Db_Obj_Lnk>;
    dxFlow_Obj_Properties: Array<DxFlow_Obj_Property>;
    change_Ind: string;
    error_Cd: string;
    error_Msg: string;
    ref_Id: number;    //ReadOnly
    ref_Cd: string; //ReadOnly
    fldr_Id: number;    //ReadOnly

    source_Properties: Array<Obj_Db_Property>;
    target_Properties: Array<Obj_Db_Property>;

    constructor() {
        this.setDefault();
    }

    setDefault(): void {
        this.kafkaProducerJob_Inst = new KafkaProducerJob_Inst();
        this.source_Properties = new Array<Obj_Db_Property>();
        this.target_Properties = new Array<Obj_Db_Property>();
        this.conn_Db_Obj_Lnks = new Array<Conn_Db_Obj_Lnk>();
        this.dxFlow_Obj_Properties = new Array<DxFlow_Obj_Property>();

        this.change_Ind = CommonEnums.change_Ind.NO_CHANGE;
        this.error_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.ref_Id = CommonEnums.defaults.LONG_VAL;
        this.ref_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.fldr_Id = CommonEnums.defaults.LONG_VAL;
    }

    static parse(kafkaProducerJobTmp: KafkaProducerJob): KafkaProducerJob {
        let kafkaProducerJob: KafkaProducerJob = new KafkaProducerJob();
        kafkaProducerJob.copyFrom(kafkaProducerJobTmp)
        return kafkaProducerJob;
    }

    copy(): KafkaProducerJob {
        let kafkaProducerJobTmp: KafkaProducerJob = new KafkaProducerJob();

        kafkaProducerJobTmp.kafkaProducerJob_Inst = this.kafkaProducerJob_Inst.copy();
        kafkaProducerJobTmp.source_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.source_Properties);
        kafkaProducerJobTmp.target_Properties = Obj_Db_PropertiesUtil.getInstance().copy(this.target_Properties);
        kafkaProducerJobTmp.conn_Db_Obj_Lnks = Conn_Db_Obj_LnksUtil.getInstance().copy(this.conn_Db_Obj_Lnks);
        kafkaProducerJobTmp.dxFlow_Obj_Properties = DxFlow_Obj_PropertiesUtil.getInstance().copy(this.dxFlow_Obj_Properties);
        
        kafkaProducerJobTmp.change_Ind = this.change_Ind;
        kafkaProducerJobTmp.error_Cd = this.error_Cd;
        kafkaProducerJobTmp.error_Msg = this.error_Msg;
        kafkaProducerJobTmp.ref_Id = this.ref_Id;
        kafkaProducerJobTmp.ref_Cd = this.ref_Cd;
        kafkaProducerJobTmp.fldr_Id = this.fldr_Id;

        return kafkaProducerJobTmp;
    }

    copyFrom(kafkaProducerJobTmp: KafkaProducerJob): void {
        this.kafkaProducerJob_Inst.copyFrom(kafkaProducerJobTmp.kafkaProducerJob_Inst);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.source_Properties, kafkaProducerJobTmp.source_Properties);
        Obj_Db_PropertiesUtil.getInstance().copyFrom(this.target_Properties, kafkaProducerJobTmp.target_Properties);
        Conn_Db_Obj_LnksUtil.getInstance().copyFrom(this.conn_Db_Obj_Lnks, kafkaProducerJobTmp.conn_Db_Obj_Lnks);
        DxFlow_Obj_PropertiesUtil.getInstance().copyFrom(this.dxFlow_Obj_Properties, kafkaProducerJobTmp.dxFlow_Obj_Properties);

        this.change_Ind = kafkaProducerJobTmp.change_Ind;
        this.error_Cd = kafkaProducerJobTmp.error_Cd;
        this.error_Msg = kafkaProducerJobTmp.error_Msg;
        this.ref_Id = kafkaProducerJobTmp.ref_Id;
        this.ref_Cd = kafkaProducerJobTmp.ref_Cd;
        this.fldr_Id = kafkaProducerJobTmp.fldr_Id;
    }

    compare(kafkaProducerJobTmp: KafkaProducerJob): string {
        let diffString = '';

        diffString = this.kafkaProducerJob_Inst.compare(kafkaProducerJobTmp.kafkaProducerJob_Inst);
        if (diffString != '') return diffString;

        diffString = Conn_Db_Obj_LnksUtil.getInstance().compare(this.conn_Db_Obj_Lnks, kafkaProducerJobTmp.conn_Db_Obj_Lnks)
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.source_Properties, kafkaProducerJobTmp.source_Properties)
        if (diffString != '') return diffString;

        diffString = Obj_Db_PropertiesUtil.getInstance().compare(this.target_Properties, kafkaProducerJobTmp.target_Properties)
        if (diffString != '') return diffString;

        diffString = DxFlow_Obj_PropertiesUtil.getInstance().compare(this.dxFlow_Obj_Properties, kafkaProducerJobTmp.dxFlow_Obj_Properties)
        if (diffString != '') return diffString;

        return diffString;
    }

    toString(): string {
        return "RestJob [kafkaProducerJob_Inst=" + this.kafkaProducerJob_Inst +
            ", source_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.source_Properties) +
            ", target_Properties=" + Obj_Db_PropertiesUtil.getInstance().toString(this.target_Properties) +
            ", change_Ind=" + this.change_Ind +
            ", error_Cd=" + this.error_Cd +
            ", error_Msg=" + this.error_Msg +
            ", ref_Id=" + this.ref_Id +
            ", ref_Cd=" + this.ref_Cd +
            ", fldr_Id=" + this.fldr_Id +
            ", conn_Db_Obj_Lnks=" + Conn_Db_Obj_LnksUtil.getInstance().toString(this.conn_Db_Obj_Lnks) +
            ", dxFlow_Obj_Properties=" + DxFlow_Obj_PropertiesUtil.getInstance().toString(this.dxFlow_Obj_Properties) + "]"
    }

}
